import { createSelector } from "reselect";

const selectFwuCampaignsState = (state) => state.fwuCampaigns;

const selectFwuCampaigns = () =>
  createSelector(selectFwuCampaignsState, (fwuCampaignsState) => fwuCampaignsState.fwuCampaigns);

const selectFwuCampaignToEdit = () =>
  createSelector(
    selectFwuCampaignsState,
    (fwuCampaignsState) => fwuCampaignsState.fwuCampaignToEdit
  );

const selectReleaseNotesList = () =>
  createSelector(
    selectFwuCampaignsState,
    (fwuCampaignsState) => fwuCampaignsState.releaseNotesList
  );

const selectReleaseNotes = (version) =>
  createSelector(
    selectFwuCampaignsState,
    (fwuCampaignsState) => fwuCampaignsState.releaseNotesList[version]
  );

export { selectFwuCampaigns, selectFwuCampaignToEdit, selectReleaseNotesList, selectReleaseNotes };
